// extracted by mini-css-extract-plugin
export default {"indigo":"title_indigo__3LwyT","night":"title_night__rXAyg","subTextSpacing":"title_subTextSpacing__FdtF6","title":"title_title__g1lk-","subHeaderText":"title_subHeaderText__d02SY"};